// @ngInject
function ProductService() {
    return {
        canReadPrices: canReadPrices
    };

    function hasLink(links, rel) {
        var link = _.find(links, function (o) {
            return o.rel === rel;
        });

        if (link) {
            return true;
        }

        return false;
    }

    function canReadPrices(links) {
        return hasLink(links, 'read_prices');
    }
}

angular
    .module('product.service', [])
    .factory('ProductService', ProductService);
